import React from 'react'
import styled from 'styled-components'

export const Bar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: transparent;
`

export const BackSection = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    width: fit-content;
`

export const SectionModifiers = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: fit-content;
`

export const Back = styled.span`
    font-family: ${({ theme }) => theme['font-regular']};
    font-size: 16px;
    color: ${({ theme }) => theme['gray-800']};
    padding-left: 0px;
    display: flex;
    align-items: center;
`

interface PublishProps {
    published: boolean
}
export const PublishButton = styled.button<PublishProps>`
    font-family: ${({ theme }) => theme['font-semibold']};
    color: white;
    font-size: 13px;
    line-height: 16px;
    background: ${props => (props.published ? props.theme['green-700'] : props.theme['blue-500'])};
    border: 0;
    border-radius: 3px;
    width: 147px;
    height: 32px;
    transition: 0.3s;
    // margin-right: 17px;
    &:hover {
        background: ${props => (props.published ? props.theme['green-700'] : props.theme['blue-700'])};
    }
    &:active {
        background: ${props => (props.published ? props.theme['green-700'] : props.theme['blue-400'])};
    }
    cursor: ${props => (props.published ? 'default' : 'pointer')};

    i {
        margin-right: 6px;
        font-style: ${props => props.theme['font-regular']};
        font-size: 13px;
        line-height: 16px;
    }
`

interface DiscardProps {
    active: boolean
}
export const Discard = styled.button<DiscardProps>`
    font-family: ${({ theme }) => theme['font-semibold']};
    color: ${props => (props.active ? '#364159' : '#BAC0CB')};
    font-size: 15px;
    line-height: 16px;
    background: transparent;
    border: 2px solid ${({ theme }) => theme['gray-400']};
    border-radius: 3px;
    width: 147px;
    height: 32px;
    transition: 0.2s;
    &:hover {
        color: ${props => (props.active ? '#777a80' : '#BAC0CB')};
    }
    &:active {
        color: ${props => (props.active ? '#9e9e9e' : '#BAC0CB')};
    }
    cursor: ${props => (!props.active ? 'default' : 'pointer')};
`

// ----- ArrowBack section ----
const BlockOne = styled.div`
    margin-left: 6.5px;
    width: 3.25px;
    height: 3px;
    background: ${({ theme }) => theme['blue-500']};
    transition: 0.2s;
`
const BlockTwo = styled.div`
    width: 9.75px;
    height: 4.33px;
    margin: 0;
    background: ${({ theme }) => theme['blue-500']};
    transition: 0.2s;
`
const Triangle = styled.i`
    font-size: 21px;
    color: ${({ theme }) => theme['blue-500']};
    margin-bottom: 3px;
    transition: 0.2s;
`
const ArrowBackContainer = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    outline: none !important;
    text-decoration: none !important;
    width: fit-content;
    height: fit-content;
    margin-right: 0 !important;
    margin-top: 2px !important;

    &:hover {
        ${BlockOne} {
            background: ${({ theme }) => theme['blue-400']};
        }
        ${BlockTwo} {
            background: ${({ theme }) => theme['blue-400']};
        }
        ${Triangle} {
            color: ${({ theme }) => theme['blue-400']};
        }
    }
`
const Blocks = styled.span`
    margin-left: 0px;
    display: flex;
    flex-direction: column;
    border-right: 0px !important;
`

// eslint-disable-next-line react/display-name
export const ArrowBack = React.forwardRef<HTMLAnchorElement>((props, ref) => {
    return (
        <ArrowBackContainer ref={ref} {...props}>
            <Triangle className={'fas fa-caret-left'} />
            <Blocks>
                <BlockTwo />
                <BlockOne />
            </Blocks>
        </ArrowBackContainer>
    )
})
